import React, { useEffect, useState } from 'react';
import { Row, Col, message, Button, Form, Spin, Space, Typography } from 'antd';
import ListCard from 'Molecules/ListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { getOutletPosUserList } from '../../../../ducks/actions'
import { removeOutletUser, bulkRemoveOutletUsers, addOutletPosUser } from '../../../../ducks/services'
import ActionButton from 'Molecules/ActionButton';
import Search from './components/Search'
// import Roles from '../../../../routing/config/Roles';
// import { allowed } from '../../../../routing/config/utils';
import { Popup } from 'Atoms/Popup';
import { SelectField } from 'Atoms/FormElement';
import { LoadingOutlined } from '@ant-design/icons';
import { useTranslate } from 'Translate';

const antIcon = <LoadingOutlined spin />;
const { Title } = Typography;

export default (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id, activeTab, allowedEdit, allowedDelete } = props;
  const { control, formState: { errors }, handleSubmit, setValue } = useForm();
  const users = useSelector((state) => state.outlet.posUsers);
  const meta = useSelector((state) => state.outlet.posUsersMeta);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchVal, setSearchVal] = useState();
  const [visible, setVisible] = useState(false);
  const [load, setLoad] = useState(false);
  const i18n = useTranslate();
  const { t } = i18n;

  useEffect(() => {
    if (activeTab === "4")
      dispatch(getOutletPosUserList(1, limit, '', '', null, props.setLoading, id));
  }, [activeTab]);

  const colName = [
    {
      title: t("Outlet.username"),
      dataIndex: 'username',
      key: 'username',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Outlet.name"),
      dataIndex: 'user_name',
      key: 'user_name',
      className: 'enable-click',
      sorter: true
    },
    // {
    //   title: t("Outlet.email"),
    //   dataIndex: 'email',
    //   key: 'email',
    //   className: 'enable-click',
    //   sorter: true
    // },
    {
      title: t("General.status"),
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      render: (text, record) =>
        <div className='flex align-items-center'>
          <span className={text === "Active" ? "c-success" : "c-danger"}>
            {t(`General.${text?.toLowerCase()}`)}
          </span>
          {
            allowedEdit &&
            <Button type="link" onClick={() => onAction(record.id, text)}>
              {text === "Active" ? `(${t("General.deactivate")})` : `(${t("General.activate")})`}
            </Button>
          }
        </div>
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      render: (text, record) =>
        <ActionButton
          title="pos_user"
          recordId={record.id}
          onRemove={allowedDelete && onRemove}
          setLoading={props.setLoading}
          loading={props.loading}
          // allowedDelete={allowed([Roles.USERS], 'delete')}
        />
    }
  ];

  const addNew = () => {
    setVisible(true);
    setValue('user', '');
  }

  const btnList = [
    {
      title: t("Outlet.confirm_remove_users"),
      text: t("General.bulk_remove"),
      classes: 'red-btn text-white attendance-success',
      permit: true,
      action: () => onBulkRemove(),
    },
    {
      text: `+ ${t("Outlet.new_pos_user")}`,
      classes: 'attendance-success',
      action: () => addNew(),
    },
  ];

  const onSearch = (val) => {
    setPage(1);
    if (val) {
      let searching = {
        name: val?.name,
        email: val?.email
      }
      setSearchVal(searching)
      dispatch(getOutletPosUserList(1, limit, '', '', searching, props.setLoading, id));
    } else {
      setSearchVal();
      dispatch(getOutletPosUserList(1, limit, '', '', null, props.setLoading, id));
    }
  };

  const onAction = async (locUserId, status) => {
    props.setLoading(true);

    const payload = {
      id: id,
      location_user_id: locUserId,
      status_event: status === 'Active' ? 'deactivate' : 'activate'
    }

    await removeOutletUser(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Outlet.user_status_update_success"));
        setTimeout(() => dispatch(getOutletPosUserList(1, limit, '', '', searchVal, props.setLoading, id)), 500);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getOutletPosUserList(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading, id));
    } else {
      dispatch(getOutletPosUserList(pagination.current, pagination.pageSize, '', '', null, props.setLoading, id));
    }
  }

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onRemove = async (posUserId) => {
    props.setLoading(true);

    const payload = {
      id: id,
      location_user_id: posUserId,
      status_event: 'remove'
    }

    await removeOutletUser(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Outlet.pos_user_remove_success"));
        setTimeout(() => dispatch(getOutletPosUserList(1, limit, '', '', searchVal, props.setLoading, id)), 500);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onBulkRemove = async () => {
    props.setLoading(true);

    const payload = {
      users: JSON.stringify(selectedRowKeys)
    }

    await bulkRemoveOutletUsers(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        rowSelection.onChange([]);
        message.success(t("Outlet.pos_users_remove_success"));
        setTimeout(() => dispatch(getOutletPosUserList(1, limit, '', '', searchVal, props.setLoading, id)), 500);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onFinish = async (val) => {
    setLoad(true);

    const payload = {
      id: id,
      location_user_id: val?.user?.value
    }

    await addOutletPosUser(payload).then(res => {
      setLoad(false);
      if (res.data.code === 200){
        message.success(t("Outlet.pos_user_added_success"));
        setVisible(false);
        dispatch(getOutletPosUserList(1, limit, '', '', searchVal, props.setLoading, id));
      }else{
        message.error(res.data.message);
      }
    }).catch(e => {
      setLoad(false);
      message.error(e?.message);
    })
  }

  const popup = {
    closable: false,
    visibility: visible,
    content: <Spin indicator={antIcon} size="large" spinning={load}>
      <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
        <Space direction='vertical' size={30} className='w-100'>
          <Title level={4} className='m-0'>
            {t("Outlet.add_pos_user")}
          </Title>
          <SelectField
            isRequired={visible}
            fieldname='user'
            label={t("Outlet.user")}
            class='mb-1 w-100 default-select'
            initValue={''}
            control={control}
            iProps={{ placeholder: t("General.please_select") }}
            selectOption={meta?.pos_users?.map(x => ({label: x.name, value: x.id}))}
            rules={{
              required: 'User is required',
            }}
            validate={errors.user && 'error'}
            validMessage={errors.user && errors.user.message}
          />
          <Row gutter={10}>
            <Col span={12}><Button size='large' danger type="primary" className='w-100' onClick={() => {
              setVisible(false);
              setValue('user', '');
            }}>{t("General.cancel")}</Button></Col>
            {
              allowedEdit &&
              <Col span={12}><Button size='large' type="primary" className='green-btn w-100' htmlType='submit'>{t("General.confirm")}</Button></Col>
            }
          </Row>
        </Space>
      </Form>
    </Spin>,
    width: 536,
    onCancel: () => {
      setVisible(false);
      setValue('user', '');
    },
  };

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          {/* <HeadingChip title={"POS Users"} btnList={allowed([Roles.USERS], 'write') && btnList} btnHidden={selectedRowKeys.length <= 0 || !allowed([Roles.USERS], 'delete')} /> */}
          <HeadingChip title={t("Menu.pos_users")} btnList={allowedEdit ? btnList : null} btnHidden={selectedRowKeys.length <= 0} />
        </Col>
        <Col span={24} className="">
          <ListCard
            Search={Search}
            onSearch={onSearch}
            ListData={users?.list?.map(x => ({ ...x, key: x.id }))}
            onChange={onTableChange}
            ListCol={colName}
            rowSelection={rowSelection}
            pagination={{
              total: users?.total_count,
              current: page,
              pageSize: limit
            }}
          />
        </Col>
      </Row>
      <Popup {...popup} />
    </>
  )
}